import {AfterViewInit, ChangeDetectorRef, Component, EventEmitter, HostListener, Input, Output} from '@angular/core';
import {FormArray, FormBuilder, FormGroup} from '@angular/forms';
import {ReflexiveRestModel} from '../../reflexive-model/reflexive-rest-model';
import {ReflexiveField} from '../../reflexive-model/reflexive-field';
import {moveItemInArray} from '@angular/cdk/drag-drop';
import {FieldType} from '../../reflexive-model/field-type.enum';

@Component({
  selector: 'app-drag-array-field',
  templateUrl: './drag-array-field.component.html',
  styleUrls: ['./drag-array-field.component.scss']
})
export class DragArrayFieldComponent implements AfterViewInit {
  protected readonly FieldType = FieldType;
  @Input() fieldName: string;
  @Input() formGroup: FormGroup;
  @Input() model: ReflexiveRestModel;
  @Input() reflexiveField: ReflexiveField;
  @Output() valueChange: EventEmitter<any> = new EventEmitter();
  formContentBox: HTMLElement;
  isDragging = false;

  constructor(
    protected formBuilder: FormBuilder,
    protected changeDetector: ChangeDetectorRef,
  ) {
  }

  onDragStart() {
    this.isDragging = true;
    this.changeDetector.detectChanges();
  }

  onDragEnd() {
    this.isDragging = false;
  }

  @HostListener('document:mousemove', ['$event'])
  onMouseMove(event: MouseEvent) {
    if (!this.isDragging) {
      return;
    }

    this.autoScroll(this.formContentBox, event.clientY);
  }

  autoScroll(container: HTMLElement, clientY: number) {
    const {top, bottom} = container.getBoundingClientRect();

    if (clientY < top + 200) {
      container.scrollTop -= 10;
    } else if (clientY > bottom - 200) {
      container.scrollTop += 10;
    }
  }

  showChildField(model: ReflexiveRestModel, fieldName: string, formGroup: FormGroup): boolean {
    return model && model.fields[fieldName] &&
      (!model.fields[fieldName].isVisible || model.fields[fieldName].isVisible(formGroup));
  }

  addNewChild() {
    const {fields} = this.model;
    const {[this.fieldName]: fieldConfig} = fields;
    const {createChild, fields: childFields} = fieldConfig.reflexiveDragArrayConfig;

    const model = createChild();
    const fieldValue = fieldConfig.value || [];

    fieldValue.push(model);
    fieldConfig.value = fieldValue;

    const newFormGroup = model.getFormGroup(this.formBuilder, childFields);
    const formArray = this.formGroup.controls[this.fieldName] as FormArray;

    formArray.push(newFormGroup);
    formArray.markAsTouched();
    formArray.updateValueAndValidity();
  }

  removeChild(index: number) {
    const formArray = this.formGroup.controls[this.fieldName] as FormArray;
    const fieldValue = this.model.fields[this.fieldName].value as Array<ReflexiveRestModel>;

    formArray.removeAt(index);
    fieldValue.splice(index, 1);

    formArray.markAsTouched();
    formArray.updateValueAndValidity();
  }


  drop(event: any) {
    const formControls = (this.formGroup.get(this.fieldName) as FormArray).controls;
    moveItemInArray(formControls, event.previousIndex, event.currentIndex);
    this.formGroup.get(this.fieldName).updateValueAndValidity();
    this.updateModel(event.previousIndex, event.currentIndex);
  }

  updateModel(previousIndex: number, currentIndex: number) {
    const item = this.model.fields[this.fieldName].value.splice(previousIndex, 1)[0];
    this.model.fields[this.fieldName].value.splice(currentIndex, 0, item);
  }


  getFormGroups(formGroup: FormGroup): Array<FormGroup> {
    return (formGroup.get(this.fieldName) as FormArray).controls as Array<FormGroup>;
  }

  ngAfterViewInit() {
    this.formContentBox = document.querySelector('.form-content-box');
  }

  allowRemoveModel(childFormGroup: FormGroup): boolean {
    return this.reflexiveField
      && this.reflexiveField.reflexiveDragArrayConfig
      && this.reflexiveField.reflexiveDragArrayConfig.allowRemoveModel(childFormGroup);
  }
}
